import React, { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";
import usePlan from "../PlanSelector/usePlan";
import {
  PricingPicker,
  PricingSwitchContainer,
  PricingText,
  SubTitle,
} from "./index.styled";

export default () => {
  const { togglePeriod } = usePlan();
  const [switchValue, setSwitchValue] = useState("monthly");

  const toggle2 = (value) => (ev) => {
    ev.preventDefault();
    ev.stopPropagation();

    console.log(value);
    setSwitchValue(value);
    togglePeriod({ period: value });
  };

  const props = useCallback(
    (value) => ({
      switchValue,
      switch: value,
    }),
    [switchValue]
  );

  return (
    <PricingSwitchContainer>
      <PricingPicker onClick={toggle2("monthly")} {...props("monthly")}>
        <PricingText {...props("monthly")}>
          <FormattedMessage id="k.monthly" defaultMessage="Monthly" />
        </PricingText>
      </PricingPicker>

      <PricingPicker onClick={toggle2("annually")} {...props("annually")}>
        <PricingText {...props("annually")}>
          <FormattedMessage id="k.annually" defaultMessage="Annually" />
        </PricingText>
        <SubTitle {...props("annually")}>
          <FormattedMessage id="k.annually.save" defaultMessage="Annually" />
        </SubTitle>
      </PricingPicker>
    </PricingSwitchContainer>
  );
};
